module.exports = __webpack_public_path__ + "img/report-icon-active.237e3bac.svg";